import { render, staticRenderFns } from "./mis_datos.vue?vue&type=template&id=32d1b166&scoped=true"
import script from "./mis_datos.vue?vue&type=script&lang=js"
export * from "./mis_datos.vue?vue&type=script&lang=js"
import style0 from "./mis_datos.vue?vue&type=style&index=0&id=32d1b166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d1b166",
  null
  
)

export default component.exports